











































































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { Component, Prop } from 'vue-property-decorator';
import UUIFComponents from '@/shared/uuifComponent';
import { SwContentToolbar } from '@sonicwall/unified-ui-framework/src/shared/sw-content-toolbar';
import { SwSpinningProgress } from '@sonicwall/unified-ui-framework/src/shared/sw-progress';
import { SwIconButton } from '@libs-uuif/shared/sw-icon-button';
import { SwDropMenu, DropMenuItem } from '@libs-uuif/shared/sw-drop-menu';
import { SwTable, TableEntry, TableColumnConfig } from '@sonicwall/unified-ui-framework/src/shared/sw-table';
import { SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';
import { SwExpandableTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { CreateElement, VNode } from 'vue';
const cssPrefix = 'releaseType';

@Component({
  components: {
    ...UUIFComponents,
    SwIcon,
    SwSpinningProgress,
    SwContentToolbar,
    SwTable,
    SwExpandableTextfield,
    SwDropMenu,
    SwIconButton,
  },
})

export default class QuotehistoryModal extends SwExtendedVue {
  cssPrefix = cssPrefix;
  @Prop()
  showQuoteHistoryDialog: boolean;
  @Prop()
  quoteId: string;
  searchValue: string = '';
  selectedMenuItem:string = '';
  quoteHistoryColumnConfig: TableColumnConfig[] = [];
  quoteHistoryTableData:TableEntry[] = [];
  tempQuoteHistoryTableData: TableEntry[] = [];
  quoteHistoryFilterItems: DropMenuItem[] = [
    {
      id: 'activityDate',
      content: this.$t('quote.date')
      .toString(),
    },
    {
      id: 'userName',
      content: this.$t('profile.username')
      .toString(),
    },
    {
      id: 'eventName',
      content: this.$t('renewalManager.event')
      .toString(),
    },
    {
      id: 'equoteId',
      content: this.$t('quote.quoteID')
      .toString(),
    },
    {
      id: 'description',
      content: this.$t('quote.description')
      .toString(),
    },
  ];
  // search & filter
  textExpanded : boolean = false;
  search: string = '';
  filterSearch: string = '';
  appliedFilter : any = [];
  quoteMenuOpened: boolean = false;
  showSearchedTextInHeader : boolean = false;
  showFilterSearch: boolean = false;
  filterHoverValues : boolean = false;

  onClickQuoteHistoryFilterButton(filterItem : any, hoverFilter : boolean = false) {
    this.quoteMenuOpened = !this.quoteMenuOpened;
    let removeIndex : number = -1;
    this.quoteHistoryFilterItems.forEach((element: any, i: number) => {
      if (element.id === filterItem) {
        removeIndex = i;
      }
    });
    if (removeIndex !== -1) {
      this.appliedFilter.push(
        { id: this.quoteHistoryFilterItems[removeIndex].id,
          content: this.quoteHistoryFilterItems[removeIndex].content,
          value: this.filterSearch,
        });
      if (hoverFilter) {
        this.filterHoverValues = true;
      }
      this.filterSearch = '';
      this.showFilterSearch = true;
    }
  }

  onCloseAll() {
    this.searchValue = '';
    this.selectedMenuItem = '';
    this.quoteMenuOpened = false;
  }
  makeTableConfig() {
    const makeElipsis = (item: string, size = 20) => {
      if (item.length > size) {
        return `${item.slice(0, size)}...`;
      } return item;
    };
    const tableConfig: TableColumnConfig[] = [
      {
        key: 'index',
        type: 'index',
      },
      {
        key: 'activityDate',
        dataKey: 'activityDate',
        title: this.$t('bulkActivationStatus.batchDate')
        .toString(),
        sorter: true,
        width: 150,
        // tslint:disable-next-line:no-unused
      },
      {
        key: 'userName',
        dataKey: 'userName',
        title: this.$t('profile.username')
        .toString(),
        width: 200,
        // tslint:disable-next-line:no-unused
      },
      {
        key: 'eventName',
        dataKey: 'eventName',
        title: this.$t('renewalManager.event')
        .toString(),
        width: 200,
        // tslint:disable-next-line:no-unused
      },
      {
        key: 'equoteId',
        dataKey: 'equoteId',
        title: this.$t('quote.quoteID')
        .toString(),
        sorter: true,
        width: 100,
        // tslint:disable-next-line:no-unused
      },
      {
        key: 'description',
        dataKey: 'description',
        title: this.$t('common.description')
        .toString(),
        width: 200,
        // tslint:disable-next-line:no-unused
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          return (
            <div>
              { makeElipsis(data.entry.description, 56) }
            </div>
          ) as VNode;
        },
      },
    ];
    this.quoteHistoryColumnConfig = tableConfig;
  }
  makeTableData() {
    this.$store.dispatch('RenewalManagerStoreModule/getQuoteHistory', this.quoteId)
    .then((res:any) => {
      this.$store.commit('stopLoading');
      if (res.operationStatus === 'OK' && res.msgCode === 'MSWAPP:SUCCESS') {
        this.$store.commit('RenewalManagerStoreModule/setQuoteHistory', res.respList);
        const tableData = this.$store.getters['RenewalManagerStoreModule/getQuoteHistory'].map((el: any, index: any) => {
          return {
            ...el,
            _key: index,
          };
        });
        this.quoteHistoryTableData = tableData;
        this.tempQuoteHistoryTableData = tableData;
      }
    });
  }
  get tableHeight() {
    return 'calc(100vh - 430px)';
  }

  initiateFilter(event : any, filterId : number) {
    if (event.keyCode === 13) {
      if (filterId === undefined) {
        this.applyFilter();
      } else {
        this.setFilterValue(event, filterId);
      }
    }
  }

  globalFilter(event : any, filterId : number) {
    if (event.keyCode === 13) {
      if (filterId === undefined) {
        this.applyFilter();
      } else {
        this.setFilterValue(event, filterId);
      }
    }
  }

  applyFilter(isExternal: boolean = false) {
    if (!isExternal) {
      this.quoteHistoryTableData = this.tempQuoteHistoryTableData;
    }
    if (this.appliedFilter.length > 0) {
      this.appliedFilter.forEach((element : any) => {
        this.quoteHistoryTableData = this.quoteHistoryTableData.filter((order : any) => {
          const elementValueArray = element.value.split(',');
          const srcValue = order[element.id].toUpperCase();
          let flag = 0;
          elementValueArray.every((elementValue : any) => {
            if (srcValue.indexOf(elementValue.trim()
            .toUpperCase()) >= 0) {
              flag = 1;
              return false;
            }
            if (srcValue.indexOf(elementValue.trim()
            .toUpperCase()) < 0) {
              return true;
            }
          });
          if (flag === 1) {
            return true;
          }
        });
      });
    }
    if (this.search !== '') {
      this.textExpanded = false;
      const key : string = this.search.toUpperCase();
      let flag : number = 0;
      const searchKeys = ['activityDate', 'description', 'equoteId', 'eventName', 'userName'];
      this.quoteHistoryTableData = this.quoteHistoryTableData.filter((item : any) => {
        flag = 0;
        searchKeys.forEach((field) => {
          if (item[field] && (item[field].toUpperCase()).indexOf(key) >= 0) {
            flag = 1;
            return false;
          }
          if (item[field] && (item[field].toUpperCase()).indexOf(key) < 0) {
            return true;
          }
        });
        if (flag === 1) {
          return true;
        }
      });
      this.showSearchedTextInHeader = true;
    }
  }

  setFilterValue(event = undefined, index: number) {
    if (event !== undefined && this.filterSearch === '') {
      this.removeFilterBox(index);
    } else {
      this.appliedFilter.forEach((element : any, i : number) => {
        if (i === index) {
          if (event !== undefined) {
            element.value = this.filterSearch;
            this.showFilterSearch = false;
          }
        }
      });
      this.applyFilter();
    }
  }

  clearFilter() {
    this.search = '';
    this.showSearchedTextInHeader = false;
    this.applyFilter();
  }

  clearAllFilters() {
    this.appliedFilter.forEach((element : any) => {
      element.value = '';
    });
    this.appliedFilter = [];
    this.search = '';
    this.showFilterSearch = false;
    this.applyFilter();
  }

  removeFilterBox(id: number) {
    let removeIndex = -1;
    this.filterSearch = '';
    this.appliedFilter.forEach((element : any, i : number) => {
      if (element.id === id) {
        element.value = '';
        removeIndex = i;
      }
    });
    this.appliedFilter.splice(removeIndex, 1);
    this.applyFilter();
  }

  mounted() {
    this.makeTableData();
    this.makeTableConfig();
  }
  closeQuoteHistoryDialog() {
    this.$emit('closeQuoteHistoryDialog');
  }
}
